import React from "react";
import Input from "../../../../ui/common/Input";
import "./TentaclesSettingsForms.scss";
import { getFieldValue } from "../fieldValue";

const TentaclesInfoForm = ({ data, handleChanges }) => {
  return (
    <div className="inputs-container">
      <Input
        label="Bottom clicks"
        value={getFieldValue(data.bottomClicks)}
        onChange={(e) => {
          handleChanges("bottomClicks", e.target.value);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="Bottom Loyalty"
        value={getFieldValue(data.bottomLoyalty)}
        onChange={(e) => {
          handleChanges("bottomLoyalty", e.target.value);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="High Clicks"
        value={getFieldValue(data.highClicks)}
        onChange={(e) => {
          handleChanges("highClicks", e.target.value);
        }}
        fullWidth
        separateLines
      />

      <Input
        label="High Loyalty"
        value={getFieldValue(data.highLoyalty)}
        onChange={(e) => {
          handleChanges("highLoyalty", e.target.value);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="Low Clicks"
        value={getFieldValue(data.lowClicks)}
        onChange={(e) => {
          handleChanges("lowClicks", e.target.value);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="Low Loyalty"
        value={getFieldValue(data.lowLoyalty)}
        onChange={(e) => {
          handleChanges("lowLoyalty", e.target.value);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="Top Clicks"
        value={getFieldValue(data.topClicks)}
        onChange={(e) => {
          handleChanges("topClicks", e.target.value);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="Top Loyalty"
        value={getFieldValue(data.topLoyalty)}
        onChange={(e) => {
          handleChanges("topLoyalty", e.target.value);
        }}
        fullWidth
        separateLines
      />
    </div>
  );
};

export default TentaclesInfoForm;
